import createSafeContext from '@/lib/useSafeContext';

export const [useTypefaceMenu, Provider] = createSafeContext<{
  items: any;
}>();

export const TypefaceMenuProvider = ({ children, items }) => {
  return <Provider value={{ items }}>{children}</Provider>;
};
